/**
 * Created by lari on 08/06/2017.
 */

/* either pass list of kkcats (patients) to display or load kkcats */


(function () {
  'use strict';
  angular.module('finance.vckkcat')
    .component('kkcatlist', {
      restrict: 'E',
      bindings: {
        kkcats: '<?'
      },
      template: `
        <table class="table table-striped">
          <thead>
          <tr>
            <th>Bezeichnung</th>
            <th>Aktion</th>
          </tr>
          </thead>
          <tr ng-repeat="kkcat in vm.kkcats">
            <td>{{kkcat.name}}</td>
            <td>
              <button class="btn btn-primary" ng-click="vm.editKkcat(kkcat)"><i class="fa fa-edit" uib-tooltip="Editieren"></i></button>
              <button class="btn btn-danger" ng-click="vm.removeKkcat(kkcat)"><i class="fa fa-remove" uib-tooltip="Löschen"></i></button>
            </td>
          </tr>
        </table>
      `,
      controllerAs: 'vm',
      controller: ['$log', '$http', 'Rlog', 'Kkcat', 'KkcatHelper', 'vertxEventBusService',
        function ($log, $http, Rlog, Kkcat, KkcatHelper, vertxEventBusService) {
          let vm = this;
          vm.editKkcat = KkcatHelper.editKkcat;
          vm.removeKkcat = removeKkcat;
          
          vm.$onInit = function () {
            
            // unless vcclient list has been passed for test purposes, retrieve vcclient list from web
            if (angular.isUndefined(vm.kkcats)) {
              vm.kkcats = Kkcat.$search();
            }
          }; // $onInit()
          
          
          function removeKkcat(kkcat) {
            kkcat.active = false;
            kkcat.$save();
          }

          const kkcatsUpdateHandler =function (message) {
            $log.debug('debug: kkcat update received: ', message);
            let messages = message.split(':');
            if (angular.isDefined(vm.kkcats)){
              vm.kkcats.$refresh().$then(function () {
                $log.debug('debug: kkcatlist refreshed kkcats');
              }, function (error) {
                $log.debug('debug: kkcatlist refresh kkcats failed: ', error);
              });
            }
          };
          
          vertxEventBusService.on('kkcats.update', {}, kkcatsUpdateHandler);

          vm.$onDestroy = function () {
            vertxEventBusService.unregisterHandler('kkcats.update', {}, kkcatsUpdateHandler);
          };
          
        }] // controller
    }); // component
  
  // klammerfriedhof
}());